import React from "react";

const PropertySkeleton = () => {
    return (
        <div className="tw-w-full tw-bg-white tw-rounded-lg tw-shadow-md tw-overflow-hidden tw-animate-pulse">
            {/* Image placeholder */}
            <div className="tw-w-full tw-h-[170px] tw-bg-gray-200"></div>

            {/* Content placeholder */}
            <div className="tw-p-3">
                {/* Price placeholder */}
                <div className="tw-h-5 tw-bg-gray-200 tw-rounded tw-w-20 tw-mb-2"></div>

                {/* Address placeholder */}
                <div className="tw-h-3 tw-bg-gray-200 tw-rounded tw-w-full tw-mb-1"></div>
                <div className="tw-h-3 tw-bg-gray-200 tw-rounded tw-w-3/4 tw-mb-2"></div>

                {/* Property details placeholder (beds, baths, sqft) */}
                <div className="tw-flex tw-gap-3 tw-mb-2">
                    <div className="tw-h-3 tw-bg-gray-200 tw-rounded tw-w-8"></div>
                    <div className="tw-h-3 tw-bg-gray-200 tw-rounded tw-w-8"></div>
                    <div className="tw-h-3 tw-bg-gray-200 tw-rounded tw-w-12"></div>
                </div>

                {/* Heart icon placeholder */}
                <div className="tw-flex tw-justify-end">
                    <div className="tw-h-5 tw-w-5 tw-bg-gray-200 tw-rounded-full"></div>
                </div>
            </div>
        </div>
    );
};

export default PropertySkeleton;
